import { Button } from '@progress/kendo-react-buttons';
import { DrawerItemProps } from '@progress/kendo-react-layout';
import { filterClearIcon, graphIcon } from '@progress/kendo-svg-icons';
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from '../../../../messages/en-US';
import WorkOrdersFilters, { WorkOrdersFiltersProps } from './WorkOrdersFilters';

export type WorkOrdersFilterPanelItemProps = DrawerItemProps &
  WorkOrdersFiltersProps & {
    onClose: () => void;
    onReset: () => void;
    onGenerate: () => void;
    generateDisabled: boolean;
  };

export function WorkOrdersFilterPanelItem({
  onClose,
  onReset,
  onGenerate,
  generateDisabled,
  ...filterProps
}: WorkOrdersFilterPanelItemProps) {
  const localizationService = useLocalization();

  return (
    <div className="flex h-screen max-h-screen min-h-0 flex-col overflow-hidden bg-white">
      <div className="flex shrink-0 items-center justify-between border-b border-slate-200 px-4 py-3">
        <span className="text-base font-semibold text-slate-900">Filters</span>
        <Button fillMode="flat" themeColor="base" onClick={onClose} aria-label="Close filters">
          ✕
        </Button>
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 py-4">
        <WorkOrdersFilters {...filterProps} />
      </div>
      <div className="shrink-0 flex gap-2 border-t border-slate-200 px-4 py-3">
        <Button fillMode="outline" themeColor="base" svgIcon={filterClearIcon} onClick={onReset} className="flex-1">
          {localizationService.toLanguageString('custom.resetFilters', enMessages.custom.resetFilters)}
        </Button>
        <Button themeColor="primary" svgIcon={graphIcon} onClick={onGenerate} disabled={generateDisabled} className="flex-1">
          {localizationService.toLanguageString('custom.updateReport', enMessages.custom.updateReport)}
        </Button>
      </div>
    </div>
  );
}
